import React, { useRef, useState } from 'react';
import { api } from '@/lib/api';
import { BACKEND_URL } from '@/lib/backendUrl';
import { Button } from '@/components/ui/button';
import { Upload, Loader2, X } from 'lucide-react';

export const mediaUrl = (u) => (u && u.startsWith('/') ? `${BACKEND_URL}${u}` : u);

export const ImageUploadButton = ({ value, onChange, pasta = 'geral', label = 'Logo', size = 'sm', testId = 'image-upload' }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const r = await api.post(`/media/upload?pasta=${pasta}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(r.data.url);
    } catch (e) {
      alert(e.response?.data?.detail || 'Falha ao enviar imagem');
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = '';
    }
  };

  return (
    <div className="flex items-center gap-2">
      {value && (
        <div className="relative">
          <img src={mediaUrl(value)} alt={label} className="w-10 h-10 rounded-md object-cover border bg-white" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange(null)} className="absolute -top-1.5 -right-1.5 bg-rose-600 text-white rounded-full w-4 h-4 flex items-center justify-center" data-testid={`${testId}-remove`}><X className="w-3 h-3" /></button>
        </div>
      )}
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-input`} />
      <Button type="button" size={size} variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testId}-btn`}>
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />}{value ? `Trocar ${label}` : `Enviar ${label}`}
      </Button>
    </div>
  );
};
